/**
 * IMPORTANT keep thus up to date
 */
export const COMMON_WEAPON_RULES = [
  "Reliable",
  "Rending",
  "Blast",
  "Limited",
  "Counter",
  "Indirect",
  "Deadly",
  "Poison",
  "Lock-On",
  "Lance",
  "AP",
  "Ignores Cover",
  "Sniper"
];
